import {
  initChart,
  getCommonOptionPie,
  printDataChart,
  printNoDataChart,
  getWidthElementChart,
} from '../common';

export function echartAccesosPieVehicles(vis, datos) {
  if (datos.resultset.length === 0) {
    printNoDataChart('#chartAccesosPie', '#no_dataAccesosPie');
  } else {
    printDataChart('#no_dataAccesosPie', '#chartAccesosPie');

    const newFontSize = getWidthElementChart('chartAccesosPie');
    const misDatosArray = datos.resultset;
    const dataPie = [];
    const COL_NOMBRE = 0;
    const COL_DATO = 1;
    const COL_ANYO = 2;
    for (let i = 0; i < misDatosArray.length; i += 1) {
      dataPie.push({
        value: misDatosArray[i][COL_DATO],
        name: misDatosArray[i][COL_NOMBRE],
      });
    }
    const option = getCommonOptionPie(
      `ACCESSOS A LA CIUTAT: DISTRIBUCIÓ ANY ${misDatosArray[0][COL_ANYO]}`,
      dataPie,
      newFontSize + 3,
    );
    initChart('chartAccesosPie', option);
  }
}
